<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="contents-wrapper">
    <div class="contents-container">
      <div class="page-icon">
        <app-zaver-icon [size]="80" name="mailCircle" ></app-zaver-icon>
      </div>

      <div class="page-text">Vennligst skriv inn din E-postadresse</div>

      <form [formGroup]="form" id="form">
        <zaver-animated-form-input
          [ariaLabel]="'Skriv inn e-postadressen'"
          [formControlName]="'email'"
          [error]="form.controls.email.invalid && showError"
          (onKeyboardEnter)="handleCtaClick()"
          inputMode="email"
          placeholder="E-postadresse"
          errorMessage="Vennligst tast inn en gyldig e-postadresse"
          [errorIcon]="'assets/icon/icon_error.svg'"
        ></zaver-animated-form-input>

        <div *ngIf="!priorConsent" class="input-container">
          <label class="consent-checkbox">
            <zaver-checkbox [formControlName]="'dataConsent'"></zaver-checkbox>
            <p class="consent-label">
              Frink AB (Zaver) kan be om mine opplysninger fra Gjeldsregisteret
              for kredittvurderingsformål. Gyldig i 6 måneder.
              Gjeldsopplysningene er levert av Gjeldsregisteret AS. Oversikt
              over finansforetak som leverer gjeldsopplysninger til
              Gjeldsregisteret AS.
              <a
                class="disclaimer-link"
                target="_blank"
                [href]="'https://www.gjeldsregisteret.com/'"
              >
                Se og administrer samtykke på gjeldsregisteret.com
              </a>
            </p>
          </label>
        </div>
      </form>
      <div class="pr-info">
        <label>Totalbeløp</label>
        <label>
          {{ state.totalCheckoutValue | value }}
        </label>
      </div>
      <zaver-primary-button
        [formId]="'form'"
        [buttonType]="'submit'"
        [text]="'Neste'"
        [disabled]="navigationInProgress || (!priorConsent && !form.controls.dataConsent.value)"
        (click)="handleCtaClick()"
      >
      </zaver-primary-button>
    </div>
  </div>
</div>
